/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagDropdownActive200,
  GetApiV1TagDropdownActive401,
  GetApiV1TagDropdownActive500,
  GetApiV1TagDropdownActiveQueryParams,
  GetApiV1TagDropdownActiveQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagDropdownActive.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1TagDropdownActiveQueryParamsSchema = z
  .object({
    personId: z.optional(z.coerce.number().int()),
    includeTags: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1TagDropdownActiveQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagDropdownActive200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1TagDropdownActive200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagDropdownActive401Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownActive401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagDropdownActive500Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownActive500>;

export const getApiV1TagDropdownActiveQueryResponseSchema = z.lazy(
  () => getApiV1TagDropdownActive200Schema,
) as unknown as ToZod<GetApiV1TagDropdownActiveQueryResponse>;
